import React from 'react';
import FailIconDisplay from '../ui/FailIconDisplay';
import { Button } from '../ui/Button';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import PlatoFooter from '../../assets/images/PlatoFooter.png';
import { useFooterLogo } from 'src/hooks/useFooterLogo';

const VerificationErrorComponent = (props) => {
    const navigate = useNavigate();
    const { t } = useTranslation();
    const footerLogoUrl = useFooterLogo();
    const footerLogoSrc = footerLogoUrl || PlatoFooter;
    const footerLogoClasses = footerLogoUrl
        ? "max-h-12 w-auto max-w-[min(240px,100%)] object-contain object-center"
        : "";
    const { 
        buttonTitle, 
        buttonNavigateUrl, 
        onClick, 
        title, 
        subtitle, 
        footerText, 
        showFooterBranding = false,
        footerBrandingText,
        buttonHref,
        largeFooterText = false
    } = props;

    const handleButtonClick = () => {
        if (onClick) {
            onClick();
        } else {
            navigate(buttonNavigateUrl || ``, { replace: true });
        }
    };

    return (
        <div className="custom-container">
            <div className="flex justify-between flex-col items-center h-full pt-[10px]">
                <div className="pt-8">
                    <div className="px-10">
                        <div className="text-h5 font-bold mb-2 text-flow-heading">
                            {title || t('errors.errorOccurredTitle')}
                        </div>
                        <div className="text-body text-Gray900">
                            {subtitle || t('errors.loadingFlowDescription')}
                        </div>
                    </div>
                    <div className="w-[313px] h-[313px]">
                        <div className="mt-4 relative">
                            <FailIconDisplay />
                        </div>
                    </div>
                    <div className="mt-2 px-3 py-3 text-center z-10">
                        <div className={`${largeFooterText ? 'text-body' : 'text-xxs'} text-Gray900`}>
                            {footerText || `${t('processing.takesLongerPrefix')} ${t('processing.contactUs')} ${t('processing.takesLongerSuffix')}`}
                        </div>
                    </div>
                    <div className="items-center py-3 bottom-0">
                        {buttonHref ? (
                            <Button
                                href={buttonHref}
                                target="_parent"
                                className="w-full"
                                variant="primaryWithoutIcon"
                            >
                                {buttonTitle}
                            </Button>
                        ) : buttonTitle && (
                            <Button
                                onClick={handleButtonClick}
                                className="mt-4"
                                variant="primaryWithoutIcon"
                            >
                                {buttonTitle}
                            </Button>
                        )}
                    </div>
                </div>
                {showFooterBranding && (
                    <div className="bg-Gray100 w-full px-5 pt-4 pb-6 rounded-t-[16px]">
                        {!footerLogoUrl && <div className="text-xxs text-Gray400">{footerBrandingText}</div>}
                        <div className={`text-h6 text-Gray900 flex justify-center ${footerLogoUrl ? "" : "mt-1"}`}>
                            <img src={footerLogoSrc} alt={t('common.verification')} className={footerLogoClasses} />
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default VerificationErrorComponent;
